var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5H15.5V15.5H0.5V3.5Z",
    fill: "#E1EBF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4V15H1V4H15ZM16 3H0V16H16V3Z",
    fill: "#788B9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H13L11 0L9 2Z",
    fill: "#4E7AB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H3L5 2L7 0Z",
    fill: "#C74343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.714C7.69686 4.714 7.40613 4.83442 7.19178 5.04878C6.97743 5.26313 6.857 5.55386 6.857 5.857C6.857 6.16014 6.97743 6.45087 7.19178 6.66522C7.40613 6.87958 7.69686 7 8 7C8.30314 7 8.59387 6.87958 8.80823 6.66522C9.02258 6.45087 9.143 6.16014 9.143 5.857C9.143 5.55386 9.02258 5.26313 8.80823 5.04878C8.59387 4.83442 8.30314 4.714 8 4.714V4.714Z",
    fill: "#967A44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.001H9V15H7V10.001Z",
    fill: "#4E7AB5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H6V9C6 7.895 6.895 7 8 7C9.105 7 10 7.895 10 9V12Z",
    fill: "#4E7AB5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.714C11.6969 4.714 11.4061 4.83442 11.1918 5.04878C10.9774 5.26313 10.857 5.55386 10.857 5.857C10.857 6.16014 10.9774 6.45087 11.1918 6.66522C11.4061 6.87958 11.6969 7 12 7C12.3031 7 12.5939 6.87958 12.8082 6.66522C13.0226 6.45087 13.143 6.16014 13.143 5.857C13.143 5.55386 13.0226 5.26313 12.8082 5.04878C12.5939 4.83442 12.3031 4.714 12 4.714V4.714Z",
    fill: "#967A44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.001H13V15H11V10.001Z",
    fill: "#4E7AB5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H10V9C10 7.895 10.895 7 12 7C13.105 7 14 7.895 14 9V12Z",
    fill: "#4E7AB5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.714C3.69686 4.714 3.40613 4.83442 3.19178 5.04878C2.97743 5.26313 2.857 5.55386 2.857 5.857C2.857 6.16014 2.97743 6.45087 3.19178 6.66522C3.40613 6.87958 3.69686 7 4 7C4.30314 7 4.59387 6.87958 4.80823 6.66522C5.02258 6.45087 5.143 6.16014 5.143 5.857C5.143 5.55386 5.02258 5.26313 4.80823 5.04878C4.59387 4.83442 4.30314 4.714 4 4.714V4.714Z",
    fill: "#967A44"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.001H5V15H3V10.001Z",
    fill: "#4E7AB5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H2V9C2 7.895 2.895 7 4 7C5.105 7 6 7.895 6 9V12Z",
    fill: "#4E7AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.18fc78dc8503e8c1211c39db376d1dbe.svg";
export { ForwardRef as ReactComponent };